import { render, staticRenderFns } from "./SelectionDataType.vue?vue&type=template&id=545e91d2&scoped=true"
import script from "./SelectionDataType.vue?vue&type=script&lang=js"
export * from "./SelectionDataType.vue?vue&type=script&lang=js"
import style0 from "./SelectionDataType.vue?vue&type=style&index=0&id=545e91d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545e91d2",
  null
  
)

export default component.exports